var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmailPurple = function SvgEmailPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 1.232a.72.72 0 0 0-.082-.32.727.727 0 0 0-.103-.154l-.012-.015-.011-.01a.741.741 0 0 0-.083-.075l-.03-.023L19.4.616l-.034-.02-.03-.016-.034-.016-.035-.014-.032-.012a.724.724 0 0 0-.038-.011l-.032-.008A.751.751 0 0 0 19.017.5L19 .5H.985a.733.733 0 0 0-.149.018l-.034.01-.036.01L.732.55.699.563.663.581C.653.585.643.59.634.596A.73.73 0 0 0 .6.616L.572.635a.708.708 0 0 0-.114.098l-.01.011-.013.015a.785.785 0 0 0-.146.255.728.728 0 0 0-.038.22L.25 1.25V14a1.502 1.502 0 0 0 1.5 1.5h16.5a1.502 1.502 0 0 0 1.5-1.5V1.232ZM18.25 14H1.75V2.955l7.743 7.098a.75.75 0 0 0 1.014 0l7.743-7.098V14Z",
    fill: "#7160C5"
  })));
};

export default SvgEmailPurple;